module.exports = __webpack_public_path__ + "img/galery.f1efde80.png";